/* Moon Basin - product description accordion. 2026-09-13 10:55 PM (Simon), on Jay:
   "accordion menu on the product pages ... the descriptions" / "Whatever is under there now".
   Progressive enhancement: the description ships as-is from Shopify (garments: text with <br><br>
   breaks and ALL-CAPS heading lines; canvases: <p><strong>HEADING</strong></p> + <ul>). This folds
   every headed section into a <details> row and leaves the opening sentence visible. No copy is
   changed; remove the script tag in layout/theme.liquid to get the flat description back. */
(() => {
  const init = () => {
    const box = document.querySelector('.mb-product__description');
    if (!box || box.dataset.mbAccordion) return;
    box.dataset.mbAccordion = '1';

    // 1. Break the description into paragraphs (arrays of nodes).
    const paras = [];
    let cur = [];
    let brRun = 0;
    const flush = () => { if (cur.some(n => (n.textContent || '').trim() || n.nodeType === 1 && n.tagName !== 'BR')) paras.push(cur); cur = []; };
    Array.from(box.childNodes).forEach((n) => {
      if (n.nodeType === 1 && n.tagName === 'BR') { brRun += 1; if (brRun >= 2) { flush(); brRun = 0; } return; }
      if (n.nodeType === 3 && !n.textContent.trim()) return;
      if (brRun === 1) cur.push(document.createElement('br'));
      brRun = 0;
      if (n.nodeType === 1 && /^(P|UL|OL|DIV|H[1-6])$/.test(n.tagName)) { flush(); paras.push([n]); return; }
      cur.push(n);
    });
    flush();

    // 2. Classify: a heading is a short ALL-CAPS line (or <p><strong>CAPS</strong></p>).
    const text = (p) => p.map(n => n.textContent || '').join('').replace(/\s+/g, ' ').trim();
    const isHeading = (p) => { const t = text(p); return t.length > 2 && t.length < 48 && /[A-Z]/.test(t) && t === t.toUpperCase() && !/[.:!?]$/.test(t); };
    const isBullets = (p) => (p.length === 1 && /^(UL|OL)$/.test(p[0].tagName || '')) || /^[•·\-]/.test(text(p));

    const sections = [];
    const intro = [];
    let open = null;
    paras.forEach((p) => {
      if (isHeading(p)) { open = { title: text(p), paras: [] }; sections.push(open); return; }
      if (open) { open.paras.push(p); return; }
      if (isBullets(p)) { sections.push({ title: 'DETAILS', paras: [p] }); return; }
      intro.push(p);
    });
    if (!sections.length) return; // nothing to fold, leave the description alone

    // 3. Rebuild.
    const frag = document.createDocumentFragment();
    const introEl = document.createElement('div'); introEl.className = 'mb-acc__intro';
    intro.forEach(p => p.forEach(n => introEl.appendChild(n)));
    if (introEl.childNodes.length) frag.appendChild(introEl);
    const acc = document.createElement('div'); acc.className = 'mb-acc';
    sections.forEach((s, i) => {
      const d = document.createElement('details'); d.className = 'mb-acc__item';
      const sum = document.createElement('summary'); sum.className = 'mb-acc__summary';
      sum.innerHTML = '<span class="mb-acc__title"></span><span class="mb-acc__chev" aria-hidden="true"></span>';
      sum.querySelector('.mb-acc__title').textContent = s.title;
      const body = document.createElement('div'); body.className = 'mb-acc__body rte';
      s.paras.forEach((p) => {
        if (p.length === 1 && p[0].nodeType === 1 && /^(P|UL|OL|DIV|H[1-6])$/.test(p[0].tagName)) { body.appendChild(p[0]); return; }
        const para = document.createElement('p'); p.forEach(n => para.appendChild(n)); body.appendChild(para);
      });
      d.appendChild(sum); d.appendChild(body); acc.appendChild(d);
      // one open at a time
      d.addEventListener('toggle', () => { if (d.open) acc.querySelectorAll('details[open]').forEach(o => { if (o !== d) o.open = false; }); });
    });
    frag.appendChild(acc);
    box.replaceChildren(frag);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* STICKY NAV AS ONE UNIT - 2026-10-18 (Simon), Jay: "I wish we could make these Word banner sticky" (phone: the garment row
   floated over the grid and the chip row slid separately on scroll / pull-to-refresh). The word rows (mood nav or mood
   filter, garment nav, Activewear chips) are template sections in #MainContent, each sticky on its own with a top that a
   scroll script re-measures from the row above (10/6-10/7). On iPhone the toolbar and rubber-band overscroll move those
   edges every frame, so the chain lags and the rows drift apart. Here the LEADING word rows are moved into the sticky
   <header> section once at load, so logo bar + rows stick as ONE block; mb-colourway.css (html.mb-docked) turns their own
   sticky off. The re-measure scripts keep running harmlessly. Visually neutral at load (the rows already sit directly
   under the header). Skipped inside the theme editor. REVERT = delete this block. */
(() => {
  const ROW = '[data-mb-mfilter],[data-mb-mood-nav],[data-mb-gnav],[data-mb-awchips]';
  const dock = () => {
    if (window.Shopify && window.Shopify.designMode) return;
    const hdr = document.querySelector('header.shopify-section');
    const main = document.getElementById('MainContent');
    if (!hdr || !main || hdr.querySelector('.mb-dock')) return;
    const rows = [];
    for (const s of Array.from(main.children)) {
      if (s.classList.contains('shopify-section') && s.querySelector(ROW)) rows.push(s); else break;
    }
    if (!rows.length) return;
    const box = document.createElement('div');
    box.className = 'mb-dock';
    rows.forEach((r) => box.appendChild(r));
    hdr.appendChild(box);
    document.documentElement.classList.add('mb-docked');
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', dock); else dock();
})();

/* Loads assets/mb-grid-colors.js - colourway chips on product grid cards (Simon, 2026-10-25).
   It hitches a ride here because this is one of the few small MBW scripts present on collection pages:
   mb-colourway.js (17KB) and layout/theme.liquid (21KB) are both over the 16,384-character
   themeFilesUpsert limit and cannot be written through the Shopify connector.
   🔑 Only the FILE NAME is swapped, so this script's ?v= cache key carries over - an unversioned asset
   URL is cached hard by the CDN and will serve a stale file. After editing mb-grid-colors.js you MUST
   re-save this file too. REVERT = delete this block. */
(() => {
  const me = document.currentScript && document.currentScript.src;
  if (!me || me.indexOf('mb-accordion.js') === -1) return;
  const s = document.createElement('script');
  s.src = me.replace('mb-accordion.js', 'mb-grid-colors.js');
  s.defer = true;
  document.head.appendChild(s);
})();